<template>
  <div class="chatbot_wrap">
    <div class="chatbot_icon" @click="openChatBot()">
      <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path
              d="M7 10C7 9.45 7.44612 9 7.99749 9C8.54887 9 9 9.45 9 10C9 10.55 8.54887 11 7.99749 11C7.44612 11 7 10.55 7 10Z"
              fill="#000000"></path>
          <path
              d="M11.9975 9C11.4461 9 11 9.45 11 10C11 10.55 11.4461 11 11.9975 11C12.5489 11 13 10.55 13 10C13 9.45 12.5489 9 11.9975 9Z"
              fill="#000000"></path>
          <path
              d="M15 10C15 9.45 15.4461 9 15.9975 9C16.5489 9 17 9.45 17 10C17 10.55 16.5489 11 15.9975 11C15.4461 11 15 10.55 15 10Z"
              fill="#000000"></path>
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M19.2 3H4.8C3.81 3 3 3.81 3 4.8V21L6.6 17.4H19.2C20.19 17.4 21 16.59 21 15.6V4.8C21 3.81 20.19 3 19.2 3ZM19.2 15.6H6.6L4.8 17.4V4.8H19.2V15.6Z"
                fill="#000000"></path>
        </g>
      </svg>
    </div>
    <div class="chatbot_box_wrap">
      <div class="chatbot_box">
        <div class="js_chat_wrap" id="chat_wrap">

          <h1 class="chat_title">
            <div class="discussion d_flex_btwn width_full">
              <div>
                Discussion <br>
                <span class="short_text">Ticket : {{ ticket.ticket_number }}</span>
              </div>
              <div class="d_flex_center">
                <button type="button" class="btn btn_md has_border_radius btn_primary mr_10" @click="openInviteModal">
                  Invite
                </button>
                <!-- <span>
                    <svg width="24px" height="24px" viewBox="0 0 8.4666669 8.4666669" id="svg8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:svg="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs id="defs2"></defs> <g id="layer1" transform="translate(0,-288.53332)"> <path d="M 15.982422 0.98828125 C 14.337427 0.98828125 12.984396 2.3413266 12.984375 3.9863281 C 12.984369 4.8776981 13.390157 5.6756992 14.015625 6.2285156 C 10.002634 7.1340307 7 10.714284 7 15 C 7 17.877413 6.9691061 21.482984 5.3085938 25.091797 C 3.9933572 25.408793 2.9960938 26.594502 2.9960938 28 C 2.9960938 29.644699 4.3572505 31.003906 6.0019531 31.003906 L 25.998047 31.003906 C 27.64275 31.003906 29.003906 29.644699 29.003906 28 C 29.003906 26.594502 28.006643 25.408793 26.691406 25.091797 C 25.030887 21.482954 25 17.877413 25 15 C 25 10.70441 21.983987 7.1158758 17.957031 6.2207031 C 18.577529 5.6681006 18.978521 4.8736001 18.978516 3.9863281 C 18.978495 2.3413266 17.627417 0.98828125 15.982422 0.98828125 z M 15.982422 2.9882812 C 16.546546 2.9882812 16.986321 3.4221958 16.986328 3.9863281 C 16.986332 4.5504604 16.546554 4.9902344 15.982422 4.9902344 C 15.41829 4.9902344 14.984371 4.5504604 14.984375 3.9863281 C 14.984382 3.4221958 15.418298 2.9882812 15.982422 2.9882812 z M 16 8 C 19.895295 8 23 11.104706 23 15 C 23 17.655912 23.076891 21.267414 24.544922 25 L 7.4550781 25 C 8.9231128 21.267414 9 17.655912 9 15 C 9 11.104706 12.104703 8 16 8 z M 6.0019531 27.001953 L 25.998047 27.001953 C 26.569344 27.001953 27.003906 27.428687 27.003906 28 C 27.003906 28.571276 26.569344 29.003906 25.998047 29.003906 L 6.0019531 29.003906 C 5.430656 29.003906 4.9980469 28.571276 4.9980469 28 C 4.9980469 27.428687 5.430656 27.001953 6.0019531 27.001953 z " id="path893" style="color:#000000;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:medium;line-height:normal;font-family:sans-serif;font-variant-ligatures:normal;font-variant-position:normal;font-variant-caps:normal;font-variant-numeric:normal;font-variant-alternates:normal;font-feature-settings:normal;text-indent:0;text-align:start;text-decoration:none;text-decoration-line:none;text-decoration-style:solid;text-decoration-color:#000000;letter-spacing:normal;word-spacing:normal;text-transform:none;writing-mode:lr-tb;direction:ltr;text-orientation:mixed;dominant-baseline:auto;baseline-shift:baseline;text-anchor:start;white-space:normal;shape-padding:0;clip-rule:nonzero;display:inline;overflow:visible;visibility:visible;opacity:1;isolation:auto;mix-blend-mode:normal;color-interpolation:sRGB;color-interpolation-filters:linearRGB;solid-color:#000000;solid-opacity:1;vector-effect:none;fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.99999988;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:stroke fill markers;color-rendering:auto;image-rendering:auto;shape-rendering:auto;text-rendering:auto;enable-background:accumulate" transform="matrix(0.26458333,0,0,0.26458333,0,288.53332)"></path> </g> </g></svg>
                </span> -->
              </div>
            </div>
            <span class="close_chat" @click="closeChatBot()">
                <i class="lni lni-close"></i>
            </span>
          </h1>
          <div class="js_chat_head chat_head " id="scrollableDiv">
            <div class="chat_head_inner">
              <ul class="ticket-chat-box" ref="chatBox">
                <div class="comments">
                  <template v-for="(chat, i) in chats" :key="'chat_'+chat.id">
                    <li :class="{reply: chat.sender_id === user.id}">
                      <div v-if="chat.sender_id !== user.id">{{ chat?.sender?.name }}</div>
                      <div class="append_inner">
                        <div v-if="chat.link" class="file">
                          <img :src="chat.link" alt="">
                        </div>
                        <div class="text">
                          <div class="time">
                            {{ chat.created_at }}
                          </div>
                          <div v-if="chat.sender_id === user.id" class="option_text">
                            <span @click="removeMessage(i, chat)"><i class="lni lni-trash-can"></i></span>
                            <span v-if="chat.read" class="checked"><i class="lni lni-checkmark"></i></span>
                          </div>
                          <h2><span>{{ chat.message }} </span></h2>
                        </div>
                      </div>
                    </li>
                  </template>
                </div>
                <div v-if="temFile" class="attached_image">
                  <img :src="temFile"  width="80" alt="">
                  <span @click="removeImage()"><i class="far fa-window-close"></i></span>
                </div>
              </ul>

            </div>
          </div>

          <div class="reply_form">
            <div class="reply_form_inner">
              <div class="attach_btn">
                <input type="file" ref="fileInput" id="upload" hidden accept="image/*"
                       @change="onFileChange($event)"/>
                <label for="upload"><i class="lni lni-paperclip"></i></label>
              </div>
              <input v-model="form.message" @keyup.enter="sendMessage" class="form_global" />
              <div class="submit" @click="sendMessage">
                <svg width="34px" height="34px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                        d="M11.5003 12H5.41872M5.24634 12.7972L4.24158 15.7986C3.69128 17.4424 3.41613 18.2643 3.61359 18.7704C3.78506 19.21 4.15335 19.5432 4.6078 19.6701C5.13111 19.8161 5.92151 19.4604 7.50231 18.7491L17.6367 14.1886C19.1797 13.4942 19.9512 13.1471 20.1896 12.6648C20.3968 12.2458 20.3968 11.7541 20.1896 11.3351C19.9512 10.8529 19.1797 10.5057 17.6367 9.81135L7.48483 5.24303C5.90879 4.53382 5.12078 4.17921 4.59799 4.32468C4.14397 4.45101 3.77572 4.78336 3.60365 5.22209C3.40551 5.72728 3.67772 6.54741 4.22215 8.18767L5.24829 11.2793C5.34179 11.561 5.38855 11.7019 5.407 11.8459C5.42338 11.9738 5.42321 12.1032 5.40651 12.231C5.38768 12.375 5.34057 12.5157 5.24634 12.7972Z"
                        stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>

          <div class="collaboration_modal" :class="{'d_none' : !showCollaborationModal}">
            <div class="collaboration_modal_inner">
                            <span class="close_collaboration_modal" @click="closeInviteModal">
                                <i class="lni lni-cross-circle"></i>
                            </span>
              <h3>Collaborate with anyone!</h3>
              <p>Invite anyone - developers, sales & marketing teams, third party vendors and more to your Freshconnect
                account.</p>
              <p class="mb_20">They will get a read only view of this context (e.g. tickets, deals, articles, etc.) and
                can participate in this discussion.</p>
              <div class="form_row">
                <label> Email Address</label>
                <div :class="['form_input', {'has_error': errorFor('email')}]">
                  <Multiselect
                      v-model="selectedUser"
                      :options="users"
                      :multiple="true"
                      :showLabels="false"
                      :close-on-select="true"
                      placeholder="Select a user"
                      track-by="id"
                      :optionHeight="20"
                      :custom-label="userLabel"
                  />
                  <v-errors :errors="errorFor('email')"></v-errors>
                </div>
              </div>
              <div class="form_row">
                <label> Need Your Help</label>
                <div class="form_input">
                  <textarea v-model="invite.help_note" class="form_global" rows="3" style="height: 40px;"
                            spellcheck="false"></textarea>
                </div>
              </div>
              <button type="button" class="btn btn_primary" @click="sendInviteTicketChatUser">Invite</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {io} from "socket.io-client";
import {Howl} from "howler";
import Multiselect from "vue-multiselect";

export default {
  name: 'chat-component',
  components: {Multiselect},
  props: {
    ticket: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      socketUrl: process.env.VUE_APP_SOCKET_URL,
      appUrl: process.env.VUE_APP_URL,
      incomingMessageSound: null,
      interval: null,
      showCollaborationModal: false,
      invite: {
        email: '',
        help_note: ''
      },
      users: [],
      chats: [],
      form: {
        message: '',
        link: ''
      },
      temFile: '',
      roomId: 'ticket-chat-'+ this.ticket.id,
      selectedUser: null
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser"
    })
  },
  mounted() {
    this.incomingMessageSound = new Howl({
      src: [`${this.appUrl}/audio.mp3`],
      volume: 1.0,
    })
    this.getUsers();
    this.getTicketChats();
  },
  methods: {
    playIncomingMessageSound() {
      this.incomingMessageSound.play();
    },
    initPusher(){
      let self = this;
      self.socket = io(this.socketUrl + '/ticket-chat');

      self.socket.emit('ticketChatSenderJoin', {agent: this.user, roomId: this.roomId});
      self.socket.on('ticketMessage', (data) => {
        if (data.event_type) {
          switch(data.event_type) {
            case 'delete':
              self.deleteEventMessage(data);
              break;
            case 'read':
              self.readStatusChange(data);
              break;
            default:
              self.handleIncomingMessage(data);
          }
        } else {
          self.handleIncomingMessage(data);
        }
      });

      /*self.socket.emit('newCustomerJoin', {roomId: roomId});
      self.socket.on('newCustomerJoiningMessage', () => {
        setTimeout(()=> {
          this.loadData();
        },100)
      })*/
      // Handle user joined messages
      /*self.socket.on('userJoined', (data) => {
        self.handleUserJoined(data);
      });*/
    },
  handleIncomingMessage(data) {
    this.playIncomingMessageSound();
    this.chats.push({ ...data });
    this.scrollDown()
  },
    handleUserJoined(data) {
      // Notify that a new user has joined
      /*this.chats.push({
        sender: data.sender,
        sender_id: data.sender_id,
        message: data.message,
        system: true // Indicate this is a system message
      });*/
      this.socket.emit('ticketMessage', {...data, roomId: this.roomId});
    },
    openChatBot() {
      document.querySelector('.chatbot_box_wrap').classList.toggle('open');
    },
    closeChatBot() {
      document.querySelector('.chatbot_box_wrap').classList.remove('open');
    },
    openInviteModal() {
      this.showCollaborationModal = true
    },
    closeInviteModal() {
      this.showCollaborationModal = false
    },
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;
      let file = event.target.files[0]
      this.form.link = file
      this.temFile= URL.createObjectURL(file)
    },
    sendInviteTicketChatUser() {
      this.allErrors = null;
      let emails = this.selectedUser?.map((user) => user.email)
      let userNames = this.selectedUser?.map((user) => user.name)
      let formattedNames = '@' + userNames.join(', @');
      this.axios.post(`/invite-for-ticket-chat/${this.ticket.id}`, {...this.invite, email: emails})
          .then(({ data }) => {
            if (data.success) {
              this.showSuccessMsg("Invite sent Successfully!");
              this.chats.push({
                id: '',
                sender_id: this.user.id,
                sender: this.user,
                created_at: 'Just Now',
                read: 0,
                message: formattedNames + ': ' + this.invite.help_note
              })

              this.resetInviteForm();
              this.closeInviteModal();
              this.getUsers();
            } else {
              this.showFailMsg(data.message);
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
    },
    getUsers() {
      this.axios.get(`/get-users-for-invite/${this.ticket.id}`)
          .then(({data}) => {
            this.users = data
          })
    },
    getTicketChats() {
      this.axios.get(`/get-ticket-chat/${this.ticket.id}`)
          .then(({data}) => {
            this.chats = data.data
            this.initPusher()
            this.scrollDown()
          })
    },
    sendMessage(){
      if(this.form.message || this.form.link) {

        /*let index = this.chats.push({
          id: '',
          sender_id: this.user.id,
          created_at: 'Just Now',
          read: 0,
          message: this.form.message
        })*/
        setTimeout(()=>{
          this.scrollDown()
        },20)

        let formData = new FormData()

        window.$.each(this.form, function( key,  file) {
          formData.append(key, file);
        });
        this.removeImage()
        this.form.message = ''
        this.axios.post(`/ticket-chat/send-message/${this.ticket.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        })
          .then((response) => {
            /*this.chats[index-1].id = response.data.data.id
            this.chats[index-1].created_at = response.data.data.created_at
            this.chats[index-1].link = response.data.data.link
            this.chats[index-1].sender_id = response.data.data.sender_id*/

            this.socket.emit('ticketMessage', {...response.data.data, roomId: this.roomId});

            setTimeout(()=>{
              this.scrollDown()
              this.removeImage()
            },20)
          });
      }
    },
    removeImage(){
      this.temFile = ''
      this.form.link = ''
      this.$refs.fileInput.value = ''
    },
    openFileModal() {
      this.$refs.fileInput.click();
    },
    readStatusChange(chat){
      if (parseInt(this.user.id) === parseInt(chat.sender_id)) {
        this.chats.map((item)=> item.read = 1)
      }
    },
    makeReadMessages(){
        this.axios.get(`/ticket-chat/message-unread/${this.ticket.id}?sender_id=` + this.user.id)
            .then((response) => {
              this.socket.emit('ticketMessage', response.data);
            })
    },
    removeMessage(i, message){
      this.axios.get(`/ticket-chat/delete-message/${this.ticket.id}?id=`+message.id)
          .then((response)=>{
            this.socket.emit('ticketMessage', response.data);
            this.chats.splice(i, 1);
          })
    },
    deleteEventMessage(event){
      if (parseInt(this.user.id) === parseInt(event.sender_id)) {
        let index = this.chats.findIndex((item) => item.id === parseInt(event.id))
        if (index !== -1) {
          this.chats.splice(index, 1);
        }
      }
    },
    scrollDown() {
      if(this.chats.length) {
        this.$nextTick(() => {
          const chatBox = this.$refs.chatBox;
          chatBox.scrollTop = chatBox.scrollHeight;
        });
      }
    },
    resetInviteForm(){
      this.invite.email = ''
      this.invite.help_note = ''
      this.selectedUser = null
    },
    userLabel(option) {
      const user = this.users.find(user => user.id === option);
      return user ? user.name + - + user.email : option.name +' - '+ option.email;
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.d_block {
  display: block !important;
}

.d_none {
  display: none !important;
}
.ticket-chat-box {
  overflow-y: auto;
  margin-top: 10px;
}
</style>